module.exports = __webpack_public_path__ + "./images/discussion-1024.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/discussion-1024.jpg
// module id = 13
// module chunks = 0